!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t((e = e || self)["world-wide-web"] = {});
}(this, function (e) {
  "use strict";

  var t = function t(e, _t) {
    void 0 === _t && (_t = 1);
    var n = e.url.split("/"),
        o = n.length;
    return n.slice(0, o - _t).join("/");
  };

  e.getUnparameterizedUrl = function (e) {
    for (var t = "", n = e.path, o = e.url, r = 0; r < n.length && n[r] === o[r]; r++) t += n[r];

    return "/" === t[t.length - 1] ? t.slice(0, t.length - 1) : t;
  }, e.getUrlSubSlashes = t, e.goBackBySlashes = function (e, n, o, r) {
    void 0 === o && (o = 1), e.push({
      pathname: t(n, o),
      search: r || ""
    });
  }, e.goBackBySlashesReplace = function (e, n, o, r) {
    void 0 === o && (o = 1), e.replace({
      pathname: t(n, o),
      search: r || ""
    });
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});